import React, {memo, useState} from 'react';
import {Platform, View} from 'react-native';

import { StyleSheet } from 'react-native';

import {SVGIcon, RNEText, RNEIconButton, RNEButton} from '../../components';
import { width, height, totalSize } from 'react-native-dimension';
import { useSoftDeleteUserAccount } from '../../server/react-query/usePatientProfile';
import {useToast} from 'react-native-fast-toast';

interface DoctorAccountDeletionModalProps {
  userId: any,
  onClose?: () => void;
  onComplete?: () => void;
}

function DoctorAccountDeletionModal(
  props: DoctorAccountDeletionModalProps,
) {

  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
    
  const deleteUserAccountMutate = useSoftDeleteUserAccount();

  const onCancel = () => {
    props.onClose();
  }

  const handleDeleteDoctorAccount = async() => {
    try {
        if(!props?.userId){
            return false;
        }
        setIsLoading(true);

        await deleteUserAccountMutate.mutateAsync(props?.userId);
        props.onComplete();
        setIsLoading(false);

    } catch (error) {
        if (error?.data?.error) {
            props.onClose();
            toast?.show(error?.data?.error, {type: 'danger'});
        }
        setIsLoading(false);
    }
  }

  return (
    <View style={rneStyles.root}>
      <RNEText
        label="Are you sure you want to delete this doctor?"
        variant="header"
        align="center"
        weight="600"
        color="primary"
        style={{fontSize: totalSize(1.6), fontFamily:'Quicksand-Medium'}}
        
      />
      <View style={rneStyles.subtitleContainer}>
        <RNEText
          label="Deleting this doctor means that this profile can no longer be accessed nor retrieved by the patient, the practitioners, or any House Call Administrators"
          variant="subheader"
          align="center"
          color={Platform.OS === 'web' ? 'blackLight' : 'grey'}
          style={{fontSize: totalSize(1), fontFamily:'Quicksand-Medium'}}
          
        />
      </View>

      <View style={rneStyles.actionContainer}>
                  <View style={rneStyles.buttonContainer}>
                    <RNEButton
                      disabled={isLoading}
                      title="Cancel"
                      color="secondary"
                      onPress={onCancel}
                      style={rneStyles.buttonStyle}
                      variant="outlined"
                    />
                  </View>
                  <RNEButton
                    loading={isLoading}
                    title="Delete"
                    color="secondary"
                    variant='default'
                    type='solid'
                    onPress={handleDeleteDoctorAccount}
                    style={rneStyles.buttonStyle}
                  />
        </View>
    </View>
  );
}

const titleFontSize = {
  fontSize: Platform.OS === 'web' ? 32 : totalSize(1.9),
};

const subtitleFontSize = {
  fontSize: Platform.OS === 'web' ? 24 : totalSize(1.7),
};

const rneStyles = StyleSheet.create(({
  root: {
    padding: height(0),
    margin: height(1),
    marginTop: height(4),
    marginBottom: height(4),
    height: height(30),
    justifyContent: 'center',
    alignSelf: 'center',
    maxWidth: Platform.OS === 'web' ? 500 : '95%',
  },
  subtitleContainer: {
    marginTop: height(4),
  },
  actionContainer: {
    gap: width(2),
    marginTop: height(5),
    justifyContent: 'center',
    flexDirection: 'row',
  },
  buttonContainer: {
    // marginTop: height(4),
    justifyContent: 'center',
    alignSelf: 'center',
  },
   buttonStyle: {
    width: width(12),
    borderWidth: totalSize(0.1)
  },
}));

export default memo(DoctorAccountDeletionModal);
